import React from "react";
import { NavLink } from "react-router-dom";
import { HiOutlineHome } from "@react-icons/all-files/hi/HiOutlineHome";
import { HiOutlineUserGroup } from "@react-icons/all-files/hi/HiOutlineUserGroup";
import { HiOutlineTicket } from "@react-icons/all-files/hi/HiOutlineTicket";
import { HiOutlineClipboardList } from "@react-icons/all-files/hi/HiOutlineClipboardList";
import { HiOutlineCash } from "@react-icons/all-files/hi/HiOutlineCash";
import { HiOutlineCog } from "@react-icons/all-files/hi/HiOutlineCog";
import { HiOutlineShieldCheck } from "@react-icons/all-files/hi/HiOutlineShieldCheck";
import { HiOutlineChartBar } from "@react-icons/all-files/hi/HiOutlineChartBar";
import { HiOutlineNewspaper } from "@react-icons/all-files/hi/HiOutlineNewspaper";
import { HiOutlineBookOpen } from "@react-icons/all-files/hi/HiOutlineBookOpen";
import type { IconBaseProps } from "react-icons";

type IconComp = React.ComponentType<IconBaseProps>;

const navItems: { label: string; to: string; icon: IconComp }[] = [
  { label: "Dashboard", to: "/", icon: HiOutlineHome },
  { label: "Users", to: "/users", icon: HiOutlineUserGroup },
  { label: "Organizers", to: "/organizers", icon: HiOutlineShieldCheck },
  { label: "Events", to: "/events", icon: HiOutlineClipboardList },
  { label: "Orders", to: "/orders", icon: HiOutlineTicket },
  { label: "Payouts", to: "/payouts", icon: HiOutlineCash },
  { label: "News", to: "/news", icon: HiOutlineNewspaper },
  { label: "Help", to: "/help", icon: HiOutlineBookOpen },
  { label: "Settings", to: "/settings", icon: HiOutlineCog },
  { label: "Audit Logs", to: "/audit-logs", icon: HiOutlineChartBar },
];

interface SidebarProps {
  collapsed?: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({ collapsed = false }) => {
  return (
    <aside
      className={`flex h-screen flex-col border-r border-surface-border bg-surface-base backdrop-blur-lg ${
        collapsed ? "w-20" : "w-64"
      }`}
    >
      <div className="flex items-center gap-3 px-6 py-5">
        <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary/10 text-primary">
          BA
        </div>
        {!collapsed && (
          <div>
            <p className="text-sm font-semibold text-ink">Blackadder</p>
            <p className="text-xs text-muted">Admin Console</p>
          </div>
        )}
      </div>

      <nav className="flex-1 space-y-1 px-2">
        {navItems.map((item) => {
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `group flex items-center gap-3 rounded-xl px-3 py-2 text-sm font-medium transition hover:bg-primary/10 hover:text-primary ${
                  isActive
                    ? "bg-primary/10 text-primary"
                    : "text-ink opacity-80"
                }`
              }
              end={item.to === "/"}
            >
              {React.createElement(item.icon, { className: "h-5 w-5" })}
              {!collapsed && <span>{item.label}</span>}
            </NavLink>
          );
        })}
      </nav>

      <div className="px-4 pb-6">
        <div className="rounded-xl border border-dashed border-surface-border bg-surface-alt p-3 text-xs text-muted">
          更新操作は確認モーダル + 理由入力が必須です。
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
